import React from 'react';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';
import { Checkbox, DateTimePicker, DatePicker, } from '@payit/cool-web-ui-library';
import Confirm from '../../confirm/Confirm';
import '../View.css';
import EbillService from '../../../service/EbillService';

class EbillSend extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      serviceOfferingId: '',
      filterTags: '',
      scheduleForLater: false,
      triggerAt: null,
      open: false,
      metaData: {},
      taxYear: 'taxYear',
      taxYearValue: '',
      dueDate: null,
    };
  }

  componentDidMount() {
    const { requestedState, } = this.props;
    if (requestedState) {
      this.setState({
        serviceOfferingId: requestedState.serviceOfferingId,
        filterTags: requestedState.filterTags,
      });
    }
  }

  onServiceOfferingChange = (event) => {
    this.setState({ serviceOfferingId: event.target.value, });
  };

  onfilterTagsChange = (event) => {
    this.setState({ filterTags: event.target.value, });
  };

  onScheduleForLaterChange = (scheduleForLater) => {
    this.setState({ scheduleForLater, });
  };

  onDateTimeChange = (dateTime) => {
    this.setState({ triggerAt: dateTime, });
  };

  onTaxYearValueValueChange = (event) => {
    const taxYearValue = event.target.value;
    const { taxYear, metaData, } = this.state;

    if (taxYearValue === '') {
      // Remove the key if the value is cleared
      const updatedMetaData = { ...metaData, };
      delete updatedMetaData[taxYear];
      this.setState({ metaData: updatedMetaData, taxYearValue: '', });
    } else {
      // Add or update the key-value pair in metaData
      this.setState({
        taxYearValue,
        metaData: { ...metaData, [taxYear]: taxYearValue, },
      });
    }
  };

  onDueDateChange = (dateTime) => {
    this.setState({ dueDate: dateTime, });
  };

  handleClickOpen = () => {
    this.setState({ open: true, });
  };

  handleClose = () => {
    this.setState({ open: false, });
  };

  sendEbills = () => {
    this.setState({ isLoading: true, });
    const request = {
      filterTags: this.state.filterTags.trim().length === 0 ? [] : this.state.filterTags.split(',').map(filterTag => filterTag.trim()),
    };

    if (this.state.scheduleForLater) {
      request.triggerAt = this.state.triggerAt;
    }

    if (Object.keys(this.state.metaData).length > 0) {
      request.metaData = this.state.metaData;
    }

    if (this.state.dueDate) {
      request.dueDate = this.state.dueDate;
    }

    EbillService.triggerEbills(this.state.serviceOfferingId, request)
      .catch((err) => {
        throw Error(err);
      })
      .finally(() => {
        this.handleClose();
        this.setState({
          isLoading: false, serviceOfferingId: '', filterTags: '', triggerAt: null,
        });
      });
  };

  dayDisabledFilter = (date) => {
    return date.valueOf() < Date.now();
  };

  render() {
    const {
      serviceOfferingId, filterTags, isLoading, open, scheduleForLater, triggerAt, taxYearValue, dueDate,
    } = this.state;

    return (
      <div className="content">
        <Form.Group className="mb-3" controlId="formBasicSoid">
          <Form.Label>Service Offering ID:</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter a service offering ID"
            value={serviceOfferingId}
            onChange={this.onServiceOfferingChange}
          />
        </Form.Group>
        <Form.Group className="mb-3" controlId="formBasicfilterTags">
          <Form.Label>Filter Tags:</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter filter tags (optional)"
            value={filterTags}
            onChange={this.onfilterTagsChange}
          />
          <Form.Text>Please enter filter tags separated by commas. Spaces are okay.</Form.Text>
        </Form.Group>
        <Form.Group className="mb-3" controlId="formMetaData">
          <div className="meta-data-inputs">
          <Form.Label className="mb-2">
              Tax Year:
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter tax year to send (optional)"
              value={taxYearValue}
              onChange={this.onTaxYearValueValueChange}
              className="mb-2"
            />
          </div>
        </Form.Group>
        <Form.Group className="mb-3" controlId="formBasicDueDate">
          <Form.Label>Due Date:</Form.Label>
          <DatePicker
            onChange={this.onDueDateChange}
            value={dueDate}
            hint="Specify bill due date to send (optional)"
          />
        </Form.Group>
        <Checkbox
          value={scheduleForLater}
          onChange={this.onScheduleForLaterChange}
          label="Schedule e-bills for later"
        />
        {scheduleForLater ? (
          <DateTimePicker
            onChange={this.onDateTimeChange}
            value={triggerAt}
            dateHint="Date to send e-bills"
            timeHint="Local time"
            datePickerProps={{
              dayDisabledFilter: this.dayDisabledFilter,
            }}
          />
        ) : null}
        <br />
        <div className="basic-input-content">
          <Row className="mt-3">
            <Col>
              <Button
                variant="success"
                className="ms-2"
                onClick={this.handleClickOpen}
                disabled={!serviceOfferingId || (scheduleForLater && !triggerAt)}
              >
                Send E-Bills
              </Button>
              <Confirm
                isLoading={isLoading}
                title="Send eBills"
                content={filterTags.length > 0 ? `Are you sure you want to send out eBills for Service Offering ${serviceOfferingId} using Filter Tags ${filterTags}?`
                  : `Are you sure you want to send out eBills for Service Offering ${serviceOfferingId}?`}
                open={open}
                onClose={this.handleClose}
                onYes={this.sendEbills}
                onNo={this.handleClose}
              />
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

EbillSend.defaultProps = {
  requestedState: undefined,
};

EbillSend.propTypes = {
  requestedState: PropTypes.instanceOf(Object),
};

export default EbillSend;
